import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = 'guest'

const userInfo = JSON.parse(localStorage.getItem('userInfo'))
if (userInfo && userInfo.userRole) initialRole = userInfo.userRole

export default new AclCreate({
  initial  : initialRole,
  notfound : {
    path: '/login',
    // path: '/not-authorized',
    forwardQueryParams: true
  },
  router,
  acceptLocalRules : true,
  globalRules: {
    admin : new AclRule('admin').generate(),
    staff : new AclRule('staff').or('admin').generate(),
    guest : new AclRule('guest').or('staff').or('admin').generate()
  }
})
